<script>
import {computed, defineComponent, reactive, ref, watch} from "vue";
import {useMeta} from "vue-meta";
import {useI18n} from "vue-i18n";
import Button from "primevue/button";
import MainCard from "@/components/cards/MainCard.vue";
import Dropdown from "primevue/dropdown";
import AutoComplete from "primevue/autocomplete"
import {useApiCall} from "@/composables/useApiCall";
import {loadObjects, loadUsers, sendReport} from "@/services/users";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import ButtonFileUpload from "@/components/buttons/ButtonFileUpload.vue";
import ButtonSuccess from "@/components/buttons/ButtonSuccess.vue";

export default defineComponent({
  layout: {name: 'AdminLayout'},
  components: {ButtonSuccess, ButtonFileUpload, Calendar, Dropdown, MainCard, Button, AutoComplete, InputText},
  setup() {
    useMeta({
      title: 'Отчеты'
    });
    // const store = useStore();
    // const router = useRouter();
    const {t} = useI18n();
    const users = ref([]);
    const loading = ref(false);
    const errors = ref(null)
    const isSend = ref(false)
    const fields = reactive({
      type: null,
      month: null,
      user_id: null,
      room_id: null,
      file: null,
    })
    const fieldsAgent = reactive({
      income: '',
      expenses: '',
      amountToPaid: ''
    })
    const fieldsOwner = reactive({
      area: '',
      incomePerMeter: '',
      expensesPerMeter: '',
      managementExpensesPerMeter: '',
      amountToPaid: '',
      ndflAmount: '',
      deductionAmount: '',
    })
    const typesList = computed(() => {
      return [
        {
          id: 'agent_report',
          name: t('reports.type.agent'),
        },
        {
          id: 'owner_report',
          name: t('reports.type.owner'),
        }
      ]
    })

    const {
      isLoading: isUsersLoading,
      data: usersData,
      error: usersError,
      executeApiCall: getUsersAction,
    } = useApiCall(loadUsers, true)
    const {
      isLoading: isObjectsLoading,
      data: objectsData,
      error: objectsError,
      executeApiCall: getObjectsAction,
    } = useApiCall(loadObjects, true)

    const {
      isLoading: isSendLoading,
      data: sendFormData,
      error: sendFormError,
      executeApiCall: sendAction,
    } = useApiCall(sendReport, true)

    const objects = ref([])
    const filterObjects = async (value) => {
      loading.value = true;
      if (value.query) {
        await getObjectsAction({page: 1, number: value.query})
        if (objectsData.value) {
          objects.value = [...objectsData.value.data.data]
        }
      } else {
        objects.value = []
      }
      loading.value = false;
    }

    const filterUser = async (value) => {
      loading.value = true;
      if (value.query) {
        await getUsersAction({page: 1, search: value.query})
        if (usersData.value) {
          const formatArray = []
          usersData.value.data.data.forEach(user => {
            formatArray.push({
              label: `${user.last_name ?? '-'} ${user.first_name ?? '-'} ${user.patronymic ?? '-'}`,
              value: user.id,
              phone: `${user.phone_code ? user.phone_code : ''}${user.phone}`,
            })
          })
          users.value = [...formatArray]
        }
      } else {
        users.value = []
      }
      loading.value = false;
    }

    const isValid = computed(() => {
      const err = {}
      for (const [key, value] of Object.entries(fields)) {
        if (key === 'file') {
          if (!value || (Array.isArray(value) && value.length === 0)) {
            err[key] = 'Файл не выбран'
          }
        } else {
          if (value === null || value === undefined || value === '') {
            err[key] = 'Поле обязательно'
          }
        }
      }
      for (const [key, value] of Object.entries(fields.type?.id === 'owner_report' ? fieldsOwner : fieldsAgent)) {
        if (value === null || value === undefined || value === '') {
          err[key] = 'Поле обязательно'
        }
      }
      console.log(Object.keys(err))
      return Object.keys(err).length === 0
    })

    const resetFields = () => {
      errors.value = null
      fieldsAgent.amountToPaid = ''
      fieldsAgent.expenses = ''
      fieldsAgent.income = ''
      fieldsOwner.area = ''
      fieldsOwner.incomePerMeter = ''
      fieldsOwner.expensesPerMeter = ''
      fieldsOwner.managementExpensesPerMeter = ''
      fieldsOwner.amountToPaid = ''
      fieldsOwner.ndflAmount = ''
      fieldsOwner.deductionAmount = ''
    }

    const resetForm = () => {
      fields.type = null
      fields.month = null
      fields.user_id = null
      fields.room_id = null
      fields.file = null
      resetFields()
      setTimeout(() => {
        isSend.value = true
      },100)
    }


    const sendForm = async () => {
      const formData = new FormData()
      if (fields.type?.id) {
        formData.append("type", fields.type.id)
        if (fields.month) {
          const date = new Date(fields.month);
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
          formData.append("month", month)
          formData.append("year", year)
        }
        if (fields.user_id) {
          formData.append("user_id", fields.user_id[0].value)
        }
        if (fields.file) {
          formData.append("file", fields.file)
        }
        if (fields.room_id) {
          formData.append("room_id", fields.room_id.id)
        }

        if (fields.type.id === 'owner_report') {
          formData.append("area", fieldsOwner.area)
          formData.append("incomePerMeter", fieldsOwner.incomePerMeter)
          formData.append("expensesPerMeter", fieldsOwner.expensesPerMeter)
          formData.append("managementExpensesPerMeter", fieldsOwner.managementExpensesPerMeter)
          formData.append("amountToPaid", fieldsOwner.amountToPaid)
          formData.append("ndflAmount", fieldsOwner.ndflAmount)
          formData.append("deductionAmount", fieldsOwner.deductionAmount)
        } else {
          formData.append("income", fieldsAgent.income)
          formData.append("expenses", fieldsAgent.expenses)
          formData.append("amountToPaid", fieldsAgent.amountToPaid)
        }
      }
      try {
        await sendAction(formData)
        if (sendFormData.value) {
          resetForm()
        }
      } catch {
        if (sendFormError.value?.data)
        errors.value = sendFormError.value?.data
      }
    }

    watch(() => fields,
        () => {
          isSend.value = false
        }, {deep: true})

    const loadFileMemory = (data) => {
      fields.file = data.files[0]
    }

    const onUpdate = (newVal) => {
      if (newVal.length > 1) {
        fields.user_id = [newVal[newVal.length - 1]];
      }
    }

    const deleteFile = () => {
      fields.file = null
    }

    const isFullForm = computed(() => fields.type && fields.month)
    watch(() => fields.type,
        () => {
          resetFields()
        }, {deep: true})

    return {
      t,
      isValid,
      fields,
      typesList,
      users,
      loading,
      filterUser,
      objects,
      filterObjects,
      sendForm,
      onUpdate,
      isUsersLoading,
      isObjectsLoading,
      loadFileMemory,
      deleteFile,
      errors,
      isSendLoading,
      isSend,
      isFullForm,
      fieldsAgent,
      fieldsOwner
    };
  }
});
</script>

<template>
  <section class="py-2 mb-3">
    <div class="flex justify-content-between align-items-center">
      <h1 class="reports__title">{{ t('reports.title') }}</h1>
      <div class="reports__actions">
        <ButtonSuccess v-if="isSend" label="Отчет загружен" class="reports__button-send" />
        <Button v-else :disabled="!isValid || isSendLoading" :label="t('reports.send')" class="reports__button-primary btn-primary" @click="sendForm"/>
      </div>
    </div>
  </section>

  <section class="mb-3 py-2">
    <div class="reports__form">
      <MainCard :title="t('reports.type.title')">
        <span class="p-float-label">
          <Dropdown
              v-model="fields.type"
              :options="typesList"
              optionLabel="name"
              class="w-full border-radius-15"
              inputId="type"
          />
          <label for="type" >{{t('reports.type.placeholder')}} <span style="color: red">*</span></label>
        </span>
        <span class="text-xs color-error" v-if="errors?.type">
          {{ errors.type[0] }}
        </span>
      </MainCard>
      <MainCard :title="t('reports.period.title')">
        <span class="p-float-label w-full">
          <Calendar
              v-model="fields.month"
              date-format="mm/yy"
              view="month"
              class="w-full" />
          <label for="period">{{t('reports.period.placeholder')}} <span style="color: red">*</span></label>
          <img v-if="!isObjectsLoading" src="@/assets/images/icons/calendar.svg" class="reports__icon" />
        </span>
        <span class="text-xs color-error" v-if="errors?.month || errors?.year ">
          {{ errors.month ? errors?.month[0] : errors.year[0] }}
        </span>
      </MainCard>
      <MainCard v-if="isFullForm" :title="t('reports.user.title')">
        <span class="p-float-label w-full reports__wrapper">
          <AutoComplete class="w-full" v-model="fields.user_id" :loading="true" forceSelection multiple optionLabel="label" inputId="ac" :suggestions="users" @update:modelValue="onUpdate" @complete="filterUser">
            <template #chip="slotProps">
              <div v-if="slotProps.value" class="auto-complete-item">
                  <span class="auto-complete-item__label">{{slotProps.value.label}}</span>
                  <span class="auto-complete-item__phone">{{slotProps.value.phone}}</span>
              </div>
             <div v-else class="flex" :style="{'min-height': '19px'}"></div>
            </template>
            <template #option="slotProps">
              <div v-if="slotProps.option" class="auto-complete-item">
                  <span class="auto-complete-item__label">{{slotProps.option.label}}</span>
                  <span class="auto-complete-item__phone">{{slotProps.option.phone}}</span>
              </div>
            </template>
            <template #loader>
            </template>
            <template #empty>
            <div class="p-3 text-center text-gray-500">
              <i class="pi pi-info-circle mr-2"></i>
              Ничего не найдено
            </div>
          </template>
          </AutoComplete>
          <label for="ac">{{t('reports.user.placeholder')}} <span style="color: red">*</span></label>
          <img v-if="!isUsersLoading" src="@/assets/images/icons/Search.svg" class="reports__icon" />
        </span>
        <span class="text-xs color-error" v-if="errors?.user_id">
          {{ errors.user_id[0] }}
        </span>
      </MainCard>
      <MainCard v-if="isFullForm" :title="t('reports.object.title')">
        <span class="p-float-label w-full">
          <AutoComplete class="w-full" v-model="fields.room_id" forceSelection optionLabel="number" inputId="object" :suggestions="objects" @complete="filterObjects">
            <template #empty>
              <div class="p-3 text-center text-gray-500">
                <i class="pi pi-info-circle mr-2"></i>
                Ничего не найдено
              </div>
            </template>
          </AutoComplete>
          <label for="object">{{t('reports.object.placeholder')}} <span style="color: red">*</span></label>
          <img v-if="!isObjectsLoading" src="@/assets/images/icons/Search.svg" class="reports__icon" />
        </span>
        <span class="text-xs color-error" v-if="errors?.room_id">
          {{ errors.room_id[0] }}
        </span>
      </MainCard>
    </div>
    <div v-if="isFullForm" class="reports__data">
      <span class="reports__data-title">{{t('reports.data')}}</span>
      <div v-if="fields.type?.id === 'owner_report'" class="reports__data-wrapper">
        <MainCard :title="t('reports.area')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsOwner.area" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.area.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.area">
              {{ errors.area[0] }}
            </span>
          </div>
        </MainCard>
        <MainCard :title="t('reports.revenuePerMeter')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsOwner.incomePerMeter" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.incomePerMeter">
              {{ errors.incomePerMeter[0] }}
            </span>
          </div>
        </MainCard>
        <MainCard :title="t('reports.totalCostPerMeter')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsOwner.expensesPerMeter" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.expensesPerMeter">
              {{ errors.expensesPerMeter[0] }}
            </span>
          </div>
        </MainCard>
        <MainCard :title="t('reports.managementExpensesPerMeter')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsOwner.managementExpensesPerMeter" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.managementExpensesPerMeter">
              {{ errors.managementExpensesPerMeter[0] }}
            </span>
          </div>
        </MainCard>
        <MainCard :title="t('reports.payoutAmount')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsOwner.amountToPaid" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.amountToPaid">
              {{ errors.amountToPaid[0] }}
            </span>
          </div>
        </MainCard>
        <MainCard :title="t('reports.personalIncomeTaxAmount')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsOwner.ndflAmount" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.ndflAmount">
              {{ errors.ndflAmount[0] }}
            </span>
          </div>
        </MainCard>
        <MainCard :title="t('reports.deductionAmount')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsOwner.deductionAmount" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.deductionAmount">
              {{ errors.deductionAmount[0] }}
            </span>
          </div>
        </MainCard>
      </div>
      <div v-else class="reports__data-wrapper --agent">
        <MainCard :title="t('reports.revenue')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsAgent.income" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.income">
              {{ errors.income[0] }}
            </span>
          </div>
        </MainCard>
        <MainCard :title="t('reports.reward')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsAgent.expenses" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.expenses">
              {{ errors.expenses[0] }}
            </span>
          </div>
        </MainCard>
        <MainCard :title="t('reports.pay')">
          <div class="flex flex-column w-full">
            <span class="p-float-label w-full">
            <InputText v-model="fieldsAgent.amountToPaid" inputId="data1" class="w-full" />
            <label for="data1">{{t('reports.data.placeholder')}} <span style="color: red">*</span></label>
            </span>
            <span class="text-xs color-error" v-if="errors?.amountToPaid">
              {{ errors.amountToPaid[0] }}
            </span>
          </div>
        </MainCard>
      </div>
      <MainCard :title="t('reports.file.title')">
        <div class="reports__send flex justify-content-between pb-2">
          <div v-if="fields.file" class="card__wrapper">
            <img src="@/assets/images/icons/file-text.svg" class="mr-2 h-2rem w-2rem" alt=""/>
            <span>{{ fields.file.name }}</span>
            <button @click="deleteFile" class="card__delete">x</button>
          </div>
          <div>
            <ButtonFileUpload
                @chooseFiles="loadFileMemory"
                :label="!fields.file ? t('reports.file.add') : t('reports.file.change')"
                :multiple="false"
                accept=".pdf"
                :text="!!fields.file"
                :clear-files-after-select="true"
                :classes="{'btn-fix-height': true, 'report__button-text': !!fields.file}"
            />
          </div>
          <span class="text-xs color-error" v-if="errors?.file">
          {{ errors.file[0] }}
        </span>
<!--          <span  v-if="errors?.logo" class="flex text-xs color-error mb-2">-->
<!--              {{ errors.logo }}-->
<!--          </span>-->
        </div>
      </MainCard>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.reports__title {
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
}
label {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}
.reports__form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 30px;
  row-gap: 16px;
  .p-calendar {
    border-radius: 6px !important;
    height: 46px;
    ::v-deep(input[role="combobox"]) {
      border-radius: 6px !important;
    }
  }
  ::v-deep(.card-title) {
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
  }
  ::v-deep(.p-dropdown) {
    border-radius: 6px;
    .p-dropdown-label {
      padding: 11px 16px !important;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      vertical-align: middle;
    }
  }
}
.p-dropdown-panel {
  border-radius: 15px !important;
}
:deep(.p-dropdown-label) {
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding-left: 16px;
}
::v-deep(.p-component-overlay) {
  background-color: rgba(255, 255, 255, 0.6);
}
::v-deep(.p-datatable-loading-icon) {
  path {
    fill: var(--color-primary);
  }
}
.reports__actions {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}
.reports__wrapper {
  position: relative;
}
.reports__icon {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(-360deg); }
}

.reports__button-primary {
  padding: 12.5px 68px;
}

.reports__button-send {
  padding: 12.5px 68px;
  &:hover {
    color: #333333 !important;
  }
}


::v-deep(.p-button.p-button-text) {
  color: #333333;
  &:hover {
    color: #333333 !important;
    background: white !important;
  }
}
.reports__data {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 60px;
  ::v-deep(.card-title) {
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
  }
  &-title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 4px;
  }
  &-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 16px;
    column-gap: 30px;
    @media screen and (min-width: 1600px) {
      grid-template-columns: repeat(4, 1fr);
      &.--agent {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
  ::v-deep(.p-card-body) {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
  }
  ::v-deep(.p-card-content) {
    display: flex;
    margin-top: auto !important;

  }
  ::v-deep(.p-inputtext) {
    height: 44px;
    border-radius: 6px;
  }
}
.card__wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #DBD9D9;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  span {
    word-break: break-all;
  }
}
.card__delete {
  border: none;
  background: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: auto;
  padding-left: 10px;
}
.reports__send {
  flex-direction: column;
}
::v-deep(.report__button-text) {
  &.btn-primary {
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    text-decoration: underline;
    text-decoration-style: solid;
    color: #C3987A !important;
    border: none !important;
    background: none !important;
  }
}
</style>
